import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useFormikContext} from 'formik';

import {getCommonTestsList, getCommonTestOptionsSelector} from 'src/redux/lists';
import {Store} from 'src/types/store';
import {TestScoreForm} from '../test-scores-form-wrapper';

import FormikTypeahead from 'src/components/formik-typeahead';
import Label from 'shared/components/label';
import Scores from '../scores';
import TestDate from '../test-date';

const OtherForm = () => {
  const dispatch = useDispatch();
  const formik = useFormikContext<TestScoreForm>();
  const commonTestOptions = useSelector((state: Store) => getCommonTestOptionsSelector(state));

  useEffect(() => {
    dispatch(getCommonTestsList());
  }, [dispatch]);

  return (
    <>
      <div className="portfolio-sections side-by-side">
        <Label required>
          Test Name
          <FormikTypeahead
            id="other-test-name-typeahead"
            name="name"
            options={commonTestOptions}
            placeholder="e.g. Regents Comprehensive Exam..."
            onSelect={({value: {name, abbreviation}}) => {
              formik.setValues({
                ...formik.values,
                name,
                abbreviation,
                subtype: {
                  name,
                  abbreviation,
                },
              });
            }}
            required
          />
        </Label>

        <TestDate />
      </div>
      <Scores min={0} max={1000000} />
    </>
  );
};

export default OtherForm;
